import { IconComponentConfig } from '../icon/icon-component-config.interface';

export interface IconPickerSection {
  iconType: string;
  items: IconComponentConfig[];
}
